import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, Radar, Grid3X3 } from 'lucide-react';
import CoachIcon from './icons/CoachIcon';

const BottomNav = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: '/home', icon: Home, label: 'Home' },
    { path: '/explore', icon: Grid3X3, label: 'Media' },
    { path: '/trials', icon: Calendar, label: 'Trials' },
    { path: '/ask-ai', icon: CoachIcon, label: 'iCoach' },
    { path: '/ai-discover', icon: Radar, label: 'iDiscover' },
  ];

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 border-t border-border/50 md:hidden shadow-lg backdrop-blur-md"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center h-full relative transition-all group px-3"
              data-testid={`bottom-nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon
                className={`w-5 h-5 transition-all group-hover:scale-110 ${
                  active ? 'text-primary' : 'text-muted-foreground'
                }`}
                strokeWidth={active ? 2.5 : 2}
              />
              <span
                className={`text-[10px] mt-1 transition-all ${
                  active ? 'text-primary font-semibold' : 'text-muted-foreground'
                }`}
              >
                {item.label}
              </span>
              {active && (
                <div
                  className="absolute top-0 left-1/2 transform -translate-x-1/2 w-10 h-1 rounded-b-full bg-primary"
                />
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
